export default __webpack_public_path__ + "static/media/done.a4792048.svg";